"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Secondary_1 = __importDefault(require("@carvana/showroom-forms/Button/Secondary"));
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var icons_1 = require("./icons");
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var roundApr_1 = __importDefault(require("../../../utils/roundApr"));
var TileDataContext_1 = require("../../TileDataContext");
var openSoftPullModal = function () {
    console.log('open softpull modal');
};
var NonAuthPayMonthly = function () {
    var price = (0, TileDataContext_1.useTileDataContext)().financeInfo.price;
    var _a = price !== null && price !== void 0 ? price : {}, _b = _a.apr, apr = _b === void 0 ? 0 : _b, _c = _a.monthlyPayment, monthlyPayment = _c === void 0 ? 0 : _c, _d = _a.termInMonths, termInMonths = _d === void 0 ? 0 : _d;
    return (react_1.default.createElement(Card_styles_1.Card, null,
        react_1.default.createElement(Card_styles_1.TitleWrapper, null,
            react_1.default.createElement(Card_styles_1.Title, null, "Pay Monthly"),
            react_1.default.createElement(Card_styles_1.Price, null,
                "$",
                (0, formatAndDropDecimal_1.default)(monthlyPayment),
                ' ',
                react_1.default.createElement("span", { className: "t-body-m" }, "/mo est*")),
            react_1.default.createElement(Card_styles_1.DisclaimerText, null,
                "* Monthly payment is based on a ",
                termInMonths,
                "-month term with an APR of ",
                (0, roundApr_1.default)(apr),
                "% and a $10/mo autopay discount")),
        react_1.default.createElement(Card_styles_1.GreyBar, null),
        react_1.default.createElement("div", { className: "t-body-s text-blue-6" }, "Get personalized monthly payments within 2 minutes, and no impact to your credit score."),
        react_1.default.createElement("div", { className: "t-body-s flex flex-row items-center gap-8 text-grey-5" },
            react_1.default.createElement(icons_1.FireIcon, null),
            " Roughly 78% of customers finance with us"),
        react_1.default.createElement(Secondary_1.default, { className: "!min-h-[40px] w-full", onClick: function () { return openSoftPullModal(); }, "data-analytics-id": null, "data-qa": "get-my-terms-modal-link" }, "Get Your Terms")));
};
exports.default = NonAuthPayMonthly;
//# sourceMappingURL=NonAuthPayMonthly.js.map